import React, { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
//antd
import { DeleteOutlined, DownloadOutlined, EnterOutlined, SaveOutlined } from '@ant-design/icons';
import { Col, Row, Tabs, Form, Input, Select, Button, notification, Space, Popconfirm, Image } from 'antd'
//support
import { Player } from "video-react";
import { checkAccessRole, translate } from '../../../helper';
//service
import { createBanner, detailBanner, updateBanner } from '../../../services/bannerService';
//css
import './video.scss'; // import css
//component
import MediaModal from '../../../components/Modal/ModalMedia';
import Editor from "ckeditor5-custom-build/build/ckeditor";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { ACTION, ImageDefault, MODULES, editorConfiguration } from '../../../config/const';
import { useSelector } from 'react-redux';

function DetailBanner() {
  //state
  const [loading, setLoading] = useState()
  const [dataForm, setDataForm] = useState({
    bannerLangs:{
      vi:[],
      en:[]
    }
  })
  const [isModalVisible, setModalVisible] = useState(false);
  const [image, setImage] = useState({})
  const [video, setVideo] = useState()
  const [selectedMedia, setSelectedMedia] = useState(null);

  //router
  const navigate = useNavigate();
  const params = useParams();
  const [form] = Form.useForm();
  let editorInstance = {};
  const roles = useSelector((state) => state.permission).data;

  //action
  const onSubmit = async () => {
    await form.validateFields()
    const { bannerLangs, name, actived, device } = form.getFieldValue()
    const body = {
      name,
      actived,
      device,
      bannerLangs: []
    }
    if(video && video.length > 0){
      body.urlVideo = video;
    }
    for (const item in bannerLangs) {
      bannerLangs[item].urlImage = image[item];
      bannerLangs[item].langCode = item;
      body.bannerLangs.push(bannerLangs[item])
    };
    if (!params.id) {
      const res = await createBanner(body)
      if (!res.data || res.data.code !== 200) {
        return notification.warning({
          message: res.data.message || 'Tạo biển hiệu thất bại vui lòng thử lại!',
        })
      }
      notification.success({ message: res.data.message })
    }
    if (params.id) {
      if (!checkAccessRole(roles, MODULES.EDITOR, ACTION.UPDATE)) {
        return notification.warning({
          message: 'Bạn không có quyền chỉnh sửa đối tượng này',
        })
      }
      body.id = parseInt(params.id)
      const res = await updateBanner(body)
      if (!res.data || res.data.code !== 200) {
        return notification.warning({
          message: res.data.message || 'Chỉnh sửa biển hiệu thất bại vui lòng thử lại!',
        })
      }
      notification.success({ message: res.data.message })
    }
    navigate('/banner')
  }

  const handleValueMedia = (value) => {
    if (selectedMedia.type === 'video') {
      setVideo(value[0].url)
    }
    if (selectedMedia.type === 'image') {
      let obj = {};
      obj[selectedMedia.lang] = value[0].url;
      setImage({ ...image, ...obj })
    }
  };

  const handleMedia = (value) => {
    setSelectedMedia(value);
    setModalVisible(true)
  };

  //service 
  const _detail = async (id) => {
    try {
      setLoading(true)
      const res = await detailBanner(id);
      if (!res.data || res.data.code !== 200) {
        return notification.warning({
          message: res.data.message,
        })
      }
      const { actived, bannerLangs, device, name, urlVideo } = res.data.data
      const dataform = {
        actived,
        device,
        name,
        urlVideo,
        bannerLangs: {}
      }
      let obj = {};
      for (let i = 0; i < bannerLangs.length; i++) {
        const { langCode } = bannerLangs[i];
        dataform.bannerLangs[langCode] = bannerLangs[i];
        obj[langCode] = bannerLangs[i].urlImage;
        setImage(obj);
      }
      setVideo(urlVideo);
      setDataForm(dataform)
      form.setFieldsValue(dataform)
    }
    catch (err) {
      console.log(err)
      notification.error({ message: err.message })
    } finally {
      setLoading(false)
    }
  }

  const handleDeleteMedia = (value) => {
    if (value.field === "urlImage") {
        let obj = {};
        obj[value.lang] = "";
        setImage({...image, ...obj })
    } else{
      setVideo("");
    }
  };


  //effects 
  useEffect(() => {
    if (params.id) {
      _detail(params.id);
    }
  }, [params.id])

  const ContentTab = ({ langCode }) => {
    return (
      <>
        <div>
          <Form.Item
            name={['bannerLangs', langCode, 'heading']}
            label={translate("Tiêu đề", langCode)}
            rules={[{ required: true, message: 'Vui lòng nhập tiêu đề' }]}
          >
            <Input placeholder={translate("Nhập tiêu đề", langCode)} />
          </Form.Item>
          <Form.Item
            name={['bannerLangs', langCode, 'subHeading']}
            label={translate("Phụ đề", langCode)}
          >
            <Input placeholder={translate("Nhập phụ đề", langCode)} />
          </Form.Item>
          <Form.Item
            name={['bannerLangs', langCode, 'description']}
            label={translate("Mô tả", langCode)}
            rules={[{ required: false }]}
          >
            <CKEditor
              editor={ Editor }
              config={ editorConfiguration }
              data={params && params.id && dataForm.bannerLangs && dataForm.bannerLangs[langCode] ? dataForm.bannerLangs[langCode].description : form.getFieldValue(['bannerLangs', langCode, 'description'])}
              onChange={(event, editor) => {
                const data = editor.getData();
                form.setFieldValue(['bannerLangs', langCode, 'description'], data);
                dataForm.bannerLangs[langCode].description = data;
                setDataForm(dataForm)
              }}
              onReady={(editor) => {
                editorInstance[langCode] = editor;
              }}
            />
          </Form.Item>
        </div>
        <Form.Item
          name={['bannerLangs', langCode, 'urlImage']}
          label={translate("Đường dẫn ảnh", langCode)}
        >
          <Image
          className='border rounded-lg'
          style={{ width: '80%' }}
          preview={false}
          src={image && image[langCode] && image[langCode].length > 0 ? process.env.REACT_APP_API_ENDPOINT_DEV + image[langCode] : ImageDefault} alt='AVP'
        />
        </Form.Item>
        <Space>
          <Button onClick={() => handleMedia({ key: 'single', type: 'image', lang: langCode })} icon={<DownloadOutlined />} >
              Upload image
            </Button>
            <Button danger onClick={() => handleDeleteMedia({ key: 'single', type: 'image', lang: langCode, field: 'urlImage' })} icon={<DeleteOutlined />} >
                Remove
            </Button>
        </Space>
      </>
    )
  }
  
  const ChooseTab = [
    {
      icon: 'ss',
      label: 'Tiếng Việt',
      key: 'vi',
      children: <ContentTab langCode="vi"></ContentTab>
    },
    {
      icon: 'ss',
      label: 'Tiếng Anh',
      key: 'en',
      children: <ContentTab langCode="en"></ContentTab>
    }
  ]

  return (
    <Row >
      <Form form={form}
        layout="vertical"
        name="form_in_modal"
        initialValues={{
          actived: 1,
          device: "DESKTOP"
        }}
        className='w-screen'
      >
        <div className='flex gap-5'>
          <Col span={16}>
            <Tabs
              type="card"
              defaultActiveKey="vi"
              items={ChooseTab}
            />
          </Col>
          <Col span={8} className=' border-l  border-gray-100 px-5' >
            <div className="flex justify-end mb-6 items-center">
              <Space>
                <Popconfirm
                  title={!params.id ? 'Xác nhận để tạo biển hiệu' : 'Xác nhận để chỉnh sửa biển hiệu'}
                  okText="Yes"
                  cancelText="No"
                  htmlType="submit"
                  onConfirm={() => onSubmit()}
                >
                  <Button type="primary" loading={loading}>
                    <SaveOutlined />
                    Xác nhận
                  </Button>
                </Popconfirm>
                <Button danger key="back" onClick={() => { form.resetFields(); navigate(-1) }}>
                  <EnterOutlined />
                  Quay lại</Button>
              </Space>
            </div>
            <Form.Item
              name="name"
              label="Tên"
              rules={[{ required: true, message: 'Vui lòng nhập tên' }]}
            >
              <Input placeholder='Nhập tên' />
            </Form.Item>
            <Form.Item
              name="actived"
              label="Trạng thái"
              rules={[{ required: true, message: 'Vui lòng chọn trạng thái' }]}
            >
              <Select placeholder="Chọn trạng thái">
                <Select.Option value={1}>Kích hoạt</Select.Option>
                <Select.Option value={0}>Hủy kích hoạt</Select.Option>
              </Select>
            </Form.Item>
            <Form.Item
              name="device"
              label="Thiết bị"
              rules={[{ required: true, message: 'Vui lòng chọn thiết bị' }]}
            >
              <Select placeholder="Chọn thiết bị">
                <Select.Option value="DESKTOP">PC</Select.Option>
                <Select.Option value="MOBILE">Mobile</Select.Option>
              </Select>
            </Form.Item>
            <Form.Item
              name="urlVideo"
              label="Đường dẫn video"
            >
              <Space>
              <Button onClick={() => handleMedia({ key: 'single', type: 'video', lang: '' })} icon={<DownloadOutlined />} >
                Upload video
              </Button>
              <Button danger onClick={() => handleDeleteMedia({ key: 'single', type: 'image', field: 'urlVideo' })} icon={<DeleteOutlined />} >
                Remove
              </Button>
              </Space>
            </Form.Item>
            <Player
              playsInline
              poster='data:image/png;base64,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'
              src={video ? process.env.REACT_APP_API_ENDPOINT_DEV + video : 'error'}
              autoPlay={false}
            />
          </Col>
        </div>
      </Form>
      <MediaModal isModalVisible={isModalVisible} setModalVisible={setModalVisible} setValue={(value) => handleValueMedia(value)} selectedMedia={selectedMedia}></MediaModal>
    </Row>
  )
}

export default DetailBanner